import { KeyboardSensorID } from "../../../../../library-js/sensors/KeyboardSensorID";
import { AppCommand } from "../../../../../library-js/web-app/commands/AppCommand";
import { AppCommandBinding } from "../../../../../library-js/web-app/commands/AppCommandBinding";
import { AppCommandBindingEntry } from "../../../../../library-js/web-app/commands/AppCommandBindingEntry";
import { AppCommandContext } from "../../../../../library-js/web-app/commands/AppCommandContext";
import { Rokojori } from "../../../Rokojori";

export class SetFullscreen extends AppCommand
{
  initialize()
  {
    this._name = 
    {
      en: "Toggle Fullscreen",
      de: "Vollbild umschalten" 
    }

    this._info = 
    {
      en: "Shows the app in fullscreen",
      de: "Zeigt die App in Vollbild"
    }

    this._shortCutEntries = 
    [
      AppCommandBindingEntry.forDesktop( AppCommandBinding.primaryWith( KeyboardSensorID.F10 ) )
    ]
  }

  async _execute( commandContext:AppCommandContext<any,any> ):Promise<void>
  {
    Rokojori.$.toggleFullScreen();
  }
}